import React, {Component, PropTypes} from 'react'
import {mark} from './lib/markdown'
import cx from 'classnames'

export class MarkdownText extends Component {
  static propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
  }

  static defaultProps = {
    text: '',
    className: '',
  }

  state = {
    text: mark(this.props.text),
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.text !== this.props.text) {
      this.setState({ text: mark(nextProps.text || '') })
    }
  }

  render() {
    return (
      <div
        className={cx("markdown-text", this.props.className)}
        dangerouslySetInnerHTML={{ __html: this.state.text }}
      />
    )
  }
}
